module.exports = __webpack_public_path__ + "static/img/WS.e50be138.png";